import React from 'react'
import EventManager from "../../../../services/EventManager";
import { useTranslation } from '../../../../contexts/TranslationProvider';
import '../buttons.scss'

const SaveDraftProjectTemplate = () => {
    const { t } = useTranslation();
    const handleSaveDraftProjectTemplate = async () => {
        EventManager.invoke('SaveDraftProjectTemplate', true)
    };
    return (
        <button className="navbar-button" onClick={handleSaveDraftProjectTemplate}>
            {t("navbar.saveDraftProjectTemplate")}
        </button>
    )
}

export default SaveDraftProjectTemplate